import { Component } from "vue-property-decorator"

import PickUpdateDateBase from "./pickUpdateDate.client.base"

@Component
export default class PickUpdateDateWeb extends PickUpdateDateBase {}
